import { GNB_MAIN_MENU } from '../constants';
import GnbItem from '../GnbItem';
import * as S from './style';

export default function Gnb() {
  return (
    <S.Wrapper>
      {GNB_MAIN_MENU.map((item) => (
        <S.MenuItem key={item.id} gnbId={item.id}>
          <GnbItem gnbId={item.id} href={item.href} gnbKind={item.gnbKind}>
            {item.label}
          </GnbItem>
        </S.MenuItem>
      ))}
    </S.Wrapper>
  );
}
